<template>
    <div class="form_box container">
        <div class="banner">
            <img src="@/assets/images/banner.png" alt="">
        </div>
        <h1 class="title">
            <img src="@/assets/images/form-title.png" alt="">
        </h1>
        <ul class="form_list container">
            <van-form id="formData" ref="formData" @submit="onSubmit">
                <li>
                    <label class="label_text">地区选择</label>
                    <van-field
                        readonly
                        clickable
                        name="location"
                        :value="location"
                        placeholder="请选择地区"
                        :rules="[{ required: true, message: '请选择地区' }]"
                        class="input_box"
                        @click="showArea = true"
                    >
                        <template #button>
                            <img src="@/assets/icon/select.png" alt="">
                        </template>
                    </van-field>
                </li>
                <li>
                    <label class="label_text">机构全称</label>
                    <van-field
                        name="name"
                        v-model="name"
                        @input="onInput"
                        placeholder="请至少输入连续四个字符"
                        :rules="checkName"
                        class="input_box"
                        autocomplete="off"
                    >
                    </van-field>
                    <div class="branchPop" v-if="branchPopShow">
                        <ul class="branchList">
                            <li v-for="(item, index) in branchList" :key="index" @click="onSelectName(item.institution_name)">{{item.institution_name}}</li>
                        </ul>
                    </div>
                </li>
                <li>
                    <label class="label_text">设备选择</label>
                    <van-field
                        readonly
                        clickable
                        name="iid"
                        :value="device"
                        placeholder="请选择设备"
                        :rules="[{ required: true, message: '请选择设备' }]"
                        class="input_box"
                        @click="showDevice = true"
                    >
                        <template #button>
                            <img src="@/assets/icon/select.png" alt="">
                        </template>
                    </van-field>
                </li>
            </van-form>
        </ul>
        <div class="form_tips">请尽量填写机构全称，以防止查询结果错误。</div>
        <div class="form_btn bot_button" ref="button">
            <button type="submit" @click="onQuery" class="custom_btn query_btn">查询</button>
            <button type="submit" @click="onReset" class="custom_btn reset_btn">重置</button>
        </div>
        <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                :columns-num="2"
                @confirm="onConfirmArea"
                @cancel="showArea = false"
            />
        </van-popup>
        <van-popup v-model="showDevice" position="bottom">
            <van-picker
                show-toolbar
                :columns="deviceList"
                @confirm="onConfirmDev"
                @cancel="showDevice = false"
            />
        </van-popup>
    </div>
</template>

<script>
import activity from '@/api/activity'
import { areaList } from '@vant/area-data';
export default {
    name: 'queryForm',
    components: {},
    data() {
        return {
            name:'',
            checkName:[
                {
                    required: true,
                    message: '请输入机构全称',
                    trigger: "onBlur"
                },
                {
                    validator: value => {
                        return value.length >= 4;
                    },
                    message: '请至少输入连续四个字符'
                },
            ],
            branchList: [],
            branchPopShow: false,
            location:'',
            location2: '',
            showArea: false,
            areaList: areaList,
            showDevice: false,
            deviceList: [],
            device:'',
            iid:''
        }
    },
    computed: {
    },

    created() {
    },
    mounted () {
        this.getDevList()
    },
    methods: {
        onInput(value) {
            console.log('当前输入的值：', value);
            if(value.length >= 4 && this.location2){
                this.branchPopShow = true
                this.params = {
                    name: this.name,
                    pro_name: this.location2
                }
                activity.orglist(this.params).then((res) => {
                    if (res.code === 1) {
                        console.log(111)
                        this.branchList = res.data
                    }
                })
            }
        },
        onFocus(){
            this.$refs.button.style.display = 'none'
        },
        onBlur(){
            this.$refs.button.style.display = 'block'
        },
        //选择机构名称
        onSelectName(name){
            this.branchList.forEach( (item) => {
                if (item.institution_name === name) {
                    this.name = name
                    this.branchPopShow = false
                }
            })
        },
        onConfirmArea(values) {
            this.location = values[0].name + '-' + values[1].name;
            this.location2 =  values[0].name + ',' + values[1].name;
            this.showArea = false;
        },
        // 获取设备列表
        getDevList(){
            activity.getDev().then(res => {
                console.log(res)
                if (res.code === 1) {
                    let dev = res.data.data
                    this.deviceList = dev.map(item=>{
                        return{
                            text: item.name,
                            value: item.id
                        }
                    })
                    console.log(this.deviceList)
                } else {
                    this.$toast(res.msg)
                }
            })
        },
        onConfirmDev(values){
            this.device = values.text;
            this.iid = values.value
            this.showDevice = false;
        },

        onSubmit() {
            this.params = {
                name: this.name,
                pro_name: this.location2,
                iid: this.iid
            }
            console.log(this.params)
            this.$router.push({ path: '/result', query: this.params });

            // activity.submit(this.params).then((res) => {
            //     if (res.code === 1) {
            //         this.$toast('查询成功')
            //         setTimeout(function() {
                        
            //         }, 2000)
            //     } else {
            //         this.$toast(res.msg)
            //     }
            // })
        },
        onQuery(){
            this.$refs.formData.submit();
        },
        onReset() {
            this.location = ''
            this.location2 = ''
            this.name = ''
            this.iid = ''
            this.device = ''
        },
    }
}
</script>
<style lang="scss" scoped>
    .form_box{
        min-height: 100vh;
        padding: 1px .3rem;
        background: url('~@/assets/bg/form-bg.png') top center #FFFFFF no-repeat;
        background-size: 100% auto;
        padding-bottom: 2.86rem;
        padding-bottom: cacl(2.86rem + constant(safe-area-inset-bottom));
        padding-bottom: cacl(2.86rem + env(safe-area-inset-bottom));
    }
    .banner{
        // margin: .2rem 0;
        border-radius: .2rem;
        box-shadow: 0 0.06rem 0.1rem rgba($color: #707070, $alpha: 0.13);
        overflow: hidden;
        img{
            display: block;
            width: 100%;
            height: auto;
        }
    }
    .title{
        margin: .48rem 0 .66rem;
        text-align: center;
        img{
            width: auto;
            height: .37rem;
        }
    }
    .form_tips{
        font-size: .3rem;
        color: #919191;
        text-align: center;
    }
    .branchPop{
        position: absolute;
        left: 1.4rem;
        right: 0;
        top: 100%;
        background-color: #FFFFFF;
        border-radius: .1rem;
        box-shadow: 0 0 .06rem rgba($color: #2f2f2f, $alpha: 0.13);
        z-index: 1;
        .branchList{
            list-style: none;
            max-height: 3rem;
            overflow-y: auto;
            li{
                font-size: .24rem;
                color: #000000;
                line-height: 1.6;
                padding: .1rem .3rem;
                border: none;
                cursor: pointer;
            }
        }
    }
</style>
